const blogsSections = document?.querySelectorAll(".blogs-section");

let debounceTimer;

const searchDebounce = function (fn, d) {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  debounceTimer = setTimeout(fn, d);
};

const getBlogs = (arr, blog, filter, category) => {
  let html = [...arr];

  if (filter) {
    html = html?.filter((item) =>
      item?.url?.includes(
        `/blogs/${blog === "living-fuel-tv" ? "livingfueltv" : blog}`
      )
    );
  }

  if (category && category != "*") {
    html = html?.filter((item) =>
      item?.tags?.includes(category?.replace(/-/g, " "))
    );
  }

  html = html
    ?.map((item) => {
      const image = item?.featured_image?.url || item?.image?.src;
      const title = item?.title || "";
      const postUrl = item?.url || `/blogs/${blog}/${item?.handle}` || "";
      const content =
        item?.body_html || item?.body
          ? new DOMParser()
              .parseFromString(item?.body_html || item?.body, "text/html")
              ?.body?.textContent?.slice(0, 200) + "..."
          : "";
      const author = item?.author || "";
      const publishedAt = item?.published_at;
      const date = new Date(publishedAt);

      const formatted = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      return `<div class="blog-articles__article article">
      <div class="article-card-wrapper card-wrapper underline-links-hover">
        <div class="
            card article-card
            card--standard
            
             card--media
            
            
          " style="--ratio-percent: 81.81818181818181%;">
          <div class="card__inner  color-scheme-2 gradient ratio" style="--ratio-percent: 81.81818181818181%;">
            <div class="article-card__image-wrapper card__media">
              <div class="article-card__image media media--hover-effect">
                ${image ? `<img src="${image}">` : ""}
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h2">
                  <a href="/blogs/recipes/honey-yummy-smoothie" class="full-unstyled-link"> Honey Yummy Smoothie </a>
                </h3>
                <div class="article-card__info caption-with-letter-spacing h5">
                  <span class="circle-divider">
                    <time datetime="2025-05-09T11:39:29Z">${formatted}</time>
                  </span>
                  <span>${author}</span>
                </div>
                <p class="article-card__excerpt rte-width">A healthy smoothie for those with a sweet tooth.The honey adds some sweetness and your choice of fruit flavors it to your liking. 1 scoop SuperGreens1 sliced banana½ cup frozen... </p>
                <div class="article-card__footer"></div>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <div class="article-card__info caption-with-letter-spacing h5">
                <span>Truth Digital</span>
                <span>
                  <time datetime="2025-05-09T11:39:29Z">May 9, 2025</time>
                </span>
              </div>
              <h3 class="card__heading fs-20">
                <a href="${postUrl}" class="full-unstyled-link"> ${title || ""} </a>
              </h3>
              <p class="article-card__excerpt rte-width fs-16">${content} </p>
              <div class="article-card__footer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>`;
    })
    ?.join("");
  return html;
};

const handleSearch = async (value, section, category) => {
  try {
    const pagination = section?.querySelector(".pagination-wrapper");
    const filterBlogsByTag = section?.dataset?.filter;

    if (!value || value === "*") {
      const blogsArr = JSON?.parse(
        section?.querySelector("#blogsArr")?.innerHTML || "{}"
      );

      if (blogsArr?.length > 0) {
        const html = getBlogs(blogsArr, filterBlogsByTag, "", category);
        const productsContainer = section?.querySelector(".blog-articles");

        if (productsContainer && html) {
          productsContainer.innerHTML = html;
          if (pagination) {
            pagination.style.display = "block";
          }
        } else {
          productsContainer.innerHTML = "";
        }
      }
      return;
    }
    const url = window?.location?.origin;

    const result = await fetch(
      `${url}/search/suggest.json?q=${value?.toLowerCase()}&resources[type]=article&resources[options][fields]=title,tag,body`
    );

    const resultData = await result?.json();

    const blogs = resultData?.resources?.results?.articles;

    const productsContainer = section?.querySelector(".blog-articles");
    if (blogs?.length > 0) {
      const html = getBlogs(blogs, filterBlogsByTag, true, category);

      if (productsContainer) {
        if (html) {
          productsContainer.innerHTML = html;
        } else {
          productsContainer.innerHTML = "";
        }
      }
    } else {
      productsContainer.innerHTML = "";
    }
    if (pagination) {
      pagination.style.display = "none";
    }
  } catch (e) {
    console.log(e);
  }
};

blogsSections?.forEach((item) => {
  const searchInput = item?.querySelector(".search-field input");
  const categorySelect = item?.querySelector(".category-field select");
  searchInput?.addEventListener("input", function (e) {
    const value = e?.target?.value;

    searchDebounce(() => handleSearch(value, item, categorySelect?.value), 500);
  });
  categorySelect?.addEventListener("change", function (e) {
    const value = e?.target?.value;
    const blog = item?.dataset?.filter;
    const { innerWidth } = window;

    if (value === "*") {
      window.location.href = `/blogs/${blog}${innerWidth > 640 ? "#blogs-list" : ""}`;
    } else {
      window.location.href = `/blogs/${blog}/tagged/${value}${innerWidth > 640 ? "#blogs-list" : ""}`;
    }
  });
});
